export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '4e877f82-0498-43d9-8bba-0672cf84d725';
export const MODAL_CLOSE_SEC = 2.5;
